import SubjectTeacherList from "@/controllers/subject_teacher/subject_teacher-list";

export default {
  extends: SubjectTeacherList,

  methods: {
    excelImport() {
      this.$router.push({ name: 'subjectTeacherImport' });
    },
  },
};
